var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEtLogo2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2103,
    height: 1057,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 152,
    width: 2103,
    height: 1057
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 1181.5,
    y1: 152,
    x2: 1181.5,
    y2: 1209,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "reflect",
    id: "fill1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#CCCC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#CCCC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#FFC000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 1344,
    y1: 333,
    x2: 1344,
    y2: 1028,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "reflect",
    id: "fill2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#CCCC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#CCCC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#FFC000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC000"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-130 -152)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2031.52 152C2097.16 152 2162.02 152.924 2225.94 154.728L2233 155.028 2051.26 162.737C1184.76 212.018 532.957 425.103 532.957 680.5 532.957 935.897 1184.76 1148.98 2051.26 1198.26L2233 1205.97 2225.94 1206.27C2162.02 1208.08 2097.16 1209 2031.52 1209 981.34 1209 130 972.382 130 680.5 130 388.617 981.34 152 2031.52 152Z",
    fill: "url(#fill1)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552 680.5C552 488.581 906.591 333 1344 333 1781.41 333 2136 488.581 2136 680.5 2136 872.419 1781.41 1028 1344 1028 906.591 1028 552 872.419 552 680.5Z",
    fill: "url(#fill2)",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEtLogo2);
export default __webpack_public_path__ + "static/media/etLogo2.40cbcefb67e965ae5b5393c498fc5595.svg";
export { ForwardRef as ReactComponent };